(function (upp) {
    'use strict';

    CustomerAccountService.$inject = [ '$rootScope', 'customerAccountApiService', 'accountManagerService' ];
    function CustomerAccountService($rootScope, customerAccountApiService, accountManagerService) {
        /**
         * Allows updating customer fields AFTER initialization of the app. This allows
         * #setFields to work (usually used by the live preview).
         *
         * @type {Rx.Subject<CustomerField[]>}
         */
        var fieldsSource$ = new Rx.Subject();

        /**
         * @type {Rx.BehaviorSubject<CustomerField[]>}
         */
        var fields$ = new Rx.BehaviorSubject([]);
        // Wire service and fieldsSource$ emissions to field$.
        Rx.Observable.concat(
            Rx.Observable.fromPromise(customerAccountApiService.getFields()),
            fieldsSource$
        ).subscribe(fields$.next.bind(fields$));

        /**
         * @type {Rx.BehaviorSubject<UserInfo[]>}
         */
        var accountInfo$ = new Rx.BehaviorSubject(null);
        // Wire account initial value and changes to accountInfo$
        Rx.Observable.create(function(subscription) {
            var retrieve = function() {
                customerAccountApiService.getUserInfo()
                .then(function(userInfo) { subscription.next(userInfo) })
            }
            var unsubLogin = $rootScope.$on('event:login:authenticated', retrieve);
            var unsubUpdate = accountManagerService.onUpdate$.subscribe(retrieve);
            // Trigger fisrt load
            retrieve();
            // Return the teardownlogic
            return function() {
                unsubLogin();
                unsubUpdate();
            };
        }).subscribe(accountInfo$.next.bind(accountInfo$));

        Object.defineProperties(this, {
            /**
             * @private
             * @property {Rx.Subject<CustomerField[]>} CustomerAccountService#fieldsSource$
             */
            fieldsSource$: { value: fieldsSource$ },
            /**
             * Emits the whole collection of customer field everytime it changes. On subscription,
             * subscribers get notified instantly with the last emitted customer fields.
             * @public
             * @property {Rx.Observable<CustomerField[]>} CustomerAccountService#fields$
             */
            fields$: {
                value: fields$.asObservable(),
                enumerable: true,
            },
            /**
             * Emits the currently logged in user info everytime it changes. On subscription,
             * subscribers get notified instantly with the last emitted info. Will emit null
             * after whenever the user logs out.
             * @public
             * @property {Rx.Observable<UserInfo>} CustomerAccountService#accountInfo$
             */
            accountInfo$: {
                value: accountInfo$.asObservable(),
                enumerable: true,
            }
        })
    }

    /**
     * Sets a new field collection and notifies every subscriber of
     * said changes (that subscribed via #onFieldsChange).
     *
     * This method is only needed for live preview updates and SHOULD
     * NOT be used on normal childupp runtime.
     *
     * @public
     * @method CustomerAccountService#setFields
     * @param {object[]} fields - New fields to set
     */
    CustomerAccountService.prototype.setFields = function(fields) {
        this.fieldsSource$.next(fields)
    }

    upp
    .service('customerAccountService', CustomerAccountService)
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/customer-account/services/customer-account.service.js